import Main from './components/Main';

const App = () => {
	return (
		<>
			<Main />
		</>
	);
};

export default App;
